export default "__VITE_ASSET__CAuQRKoP__"